import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './CompletionPage.css';

const CompletionPage = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="completion-page">
      <div className="completion-card">
        <h1>설문이 완료되었습니다.</h1>
        <p>참여해 주셔서 감사합니다.</p>
        <button className="completion-logout-btn" onClick={handleLogout}>
          로그아웃
        </button>
      </div>
    </div>
  );
};

export default CompletionPage;

